const goldenbill = () => import ('@/pages/inquiry/goldenbill')
const seller = () => import ('@/pages/inquiry/seller')
const comprehensive  = () => import ('@/pages/inquiry/comprehensive')
const legaltexts = () => import ('@/pages/inquiry/legaltexts')
const legaltextsSign = () => import ('@/pages/inquiry/legaltexts-sign')
export default [
    {
        path: 'inquiry/goldenbill',
        name:'goldenbill',
        component: goldenbill,
        meta:{
          // 设置该路由组件缓存，同时保证路由name == 组件name
          keepAlive:true
        }
    },
    {
        path: 'inquiry/goldenbill/seller',
        name:'inquiry/goldenbill/seller',
        component: seller
    },
    {
        path: 'inquiry/comprehensive',
        name:'inquiry/comprehensive',
        component: comprehensive
    },
    {
        path: 'inquiry/legaltexts',
        name:'inquiry/legaltexts',
        component: legaltexts
    },
    {
        path: 'inquiry/legaltexts-sign',
        name:'inquiry/legaltexts-sign',
        component: legaltextsSign
    }
]



// WEBPACK FOOTER //
// ./src/router/inquiry.js